import crudFactory from "@/api/v1/crudFactory.ts";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import type { IResponse } from "@/api";

const respondSuccess = (response: AxiosResponse): IResponse => ({
  loadingIndicator: false,
  errorIndicator: false,
  status: response.status,
  headers: response.headers,
  data: response.data,
  raw: response
});

const respondFailure = ({ error }: any) => ({ loadingIndicator: false, errorIndicator: true, error });

export class BaseHandlerV1 {
  createOne(path: string, data: any, config?: AxiosRequestConfig): Promise<IResponse> {
    return crudFactory(path)
      .createOne(data, config)
      .then((response: AxiosResponse) => respondSuccess(response))
      .catch((error) => respondFailure(error));
  }

  getOne(path: string, id: string, config?: AxiosRequestConfig): Promise<IResponse> {
    return crudFactory(path)
      .getOne(id, config)
      .then((response: AxiosResponse) => respondSuccess(response))
      .catch((error) => respondFailure(error));
  }

  async getAll(path: string, config?: AxiosRequestConfig): Promise<IResponse> {
    return crudFactory(path)
      .getAll(config)
      .then((response: AxiosResponse) => respondSuccess(response))
      .catch((error) => respondFailure(error));
  }

  updateOne(path: string, id: string, data: any, config?: AxiosRequestConfig): Promise<IResponse> {
    return crudFactory(path)
      .updateOne(id, data, config)
      .then((response: AxiosResponse) => respondSuccess(response))
      .catch((error) => respondFailure(error));
  }

  updateAll(path: string, data: any, config?: AxiosRequestConfig): Promise<IResponse> {
    return crudFactory(path)
      .updateAll(data, config)
      .then((response: AxiosResponse) => respondSuccess(response))
      .catch((error) => respondFailure(error));
  }

  deleteOne(path: string, id: string, config?: AxiosRequestConfig): Promise<IResponse> {
    return crudFactory(path)
      .deleteOne(id, config)
      .then((response: AxiosResponse) => respondSuccess(response))
      .catch((error) => respondFailure(error));
  }

  post(path: string, subpath: string, data?: any, config?: AxiosRequestConfig): Promise<IResponse> {
    return crudFactory(path)
      .post(subpath, data, config)
      .then((response: AxiosResponse) => respondSuccess(response))
      .catch((error) => respondFailure(error));
  }
}

export default BaseHandlerV1;
